module.exports = __webpack_public_path__ + "static/media/forever_tricolour_small_1.3095bba5.jpg";